import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dce6b46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modernization-sub-heading",
  "data-aos": "fade-up"
}
const _hoisted_2 = { class: "modernization-benefit-section" }
const _hoisted_3 = { class: "benefit-image-container" }
const _hoisted_4 = ["onMouseenter", "onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "benefit-image-text" }
const _hoisted_7 = ["onMouseleave", "onClick", "id"]
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.subHeading), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardItems, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              "data-aos": "fade-up",
              key: index,
              cols: 12,
              xs: 12,
              sm: 12,
              md: 6,
              lg: 6,
              xl: 6,
              style: {}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    onMouseenter: ($event: any) => (_ctx.showHover(item.id)),
                    onClick: ($event: any) => (_ctx.showOverlay(item.id))
                  }, [
                    _createElementVNode("img", {
                      src: require(`@/assets/${item.subFolder}/${item.folder}/${item.imageUrl}`),
                      alt: item.imageUrl
                    }, null, 8, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.text), 1)
                  ], 40, _hoisted_4),
                  _createElementVNode("div", {
                    class: "overlay-text",
                    onMouseleave: ($event: any) => (_ctx.hideHover(item.id)),
                    onClick: ($event: any) => (_ctx.showOverlay(item.id)),
                    id: `overlay-content-${item.id}`
                  }, [
                    _createElementVNode("img", {
                      src: require(`@/assets/capabilities/application modernization/icons/${item.hoverIcon}`),
                      alt: item.hoverIcon
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", null, _toDisplayString(item.hoverText), 1)
                  ], 40, _hoisted_7)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 64))
}